import { useState } from 'react';
import { Button } from '@predoc/cow';
import { PatientDocumentViewer, type DocumentKey } from '../viewer';

interface PatientDocumentViewButtonProps {
  documentKey: DocumentKey;
  disabled?: boolean;
  label?: string;
}

export const PatientDocumentViewButton = ({
  documentKey,
  disabled,
  label = 'View',
}: PatientDocumentViewButtonProps) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleOpen = () => setIsOpen(true);
  const handleClose = () => setIsOpen(false);

  return (
    <>
      <Button
        variant="outline"
        size="sm"
        disabled={disabled}
        onClick={handleOpen}
        aria-label={label}
      >
        {label}
      </Button>
      {isOpen ? (
        <PatientDocumentViewer
          open
          onClose={handleClose}
          documentKey={documentKey}
        />
      ) : null}
    </>
  );
};
